// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2j5I8","description":"PatientConsentPreview_description__2MsMv"};